import { Model } from '@vuex-orm/core'

export const ITEM_FLAGS = {
  canSell: 2 ** 0,
  canBet: 2 ** 1,
  canTip: 2 ** 2,
  canWithdraw: 2 ** 3,
}

class Item extends Model {
  static entity = 'items'

  static fields() {
    return {
      id: this.string(),
      // item info
      name: this.string(),
      price: this.number(0),
      color: this.string('#000000'),
      image: this.string(),
      category: this.string('misc'),
      type: this.string('misc'),
      // flags
      canWithdraw: this.boolean(false),
      canSell: this.boolean(false),
      canBet: this.boolean(false),
      canTip: this.boolean(false),
      inUse: this.boolean(false),
      inStock: this.boolean(null).nullable(),
      // misc
      origin: this.string(false),
      selected: this.boolean(false),
      isNew: this.boolean(false),
    }
  }

  get isSellable() {
    if (!this.price) return false
    if (this.inUse) return false
    if (!this.canSell) return false

    return true
  }

  get isWithdrawable() {
    if (!this.price) return false
    if (this.inUse) return false
    if (!this.canWithdraw) return false

    return true
  }

  get flags() {
    let flags = 0

    for (const [key, flag] of Object.entries(ITEM_FLAGS)) {
      if (this[key] === true) flags += flag
    }

    return flags
  }

  canSelect(context) {
    if (!this.price) return false
    if (this.inUse) return false

    if (context === 'sell') {
      if (!this.canSell) return false
    }

    if (context === 'withdraw') {
      if (!this.canWithdraw) return false
      if (!this.inStock) return false
    }

    if (context === 'bet') {
      if (!this.canBet) return false
    }

    if (context === 'tip') {
      if (!this.canTip) return false
    }

    return true
  }

  static beforeCreate(model) {
    model.id = model._id // convert mongo id
  }
}

export default Item
